module.exports = __webpack_public_path__ + "img/map-marker-selected.b2aaf526.png";